import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import { data } from '../utils/data';
import { HackathonData } from '../utils/data_types';
import { THEME_COLORS } from '../utils/theme';

const SelectorContainer = styled.div`
  display: flex;
  width: 80%;
  margin: 50px auto;
  justify-content: space-between;
  max-width: 1200px;
  overflow: auto;
`;

const Year = styled.div<{ isSelected: boolean }>`
  cursor: pointer;
  font-family: 'Work Sans';
  font-weight: ${props => (props.isSelected ? 700 : 500)};
  font-size: 20px;
  color: ${props => (props.isSelected ? THEME_COLORS.brandPink : 'black')};
  text-decoration: none;
  padding-bottom: 5px;
  margin: 0 5px;
  background-clip: border-box;
  border-bottom: ${props => (props.isSelected ? '2.5px solid #f63690' : '')};
`;

interface Props {
  setData: React.Dispatch<React.SetStateAction<HackathonData>>;
}

export const YearSelector: React.FC<Props> = ({ setData }) => {
  const [year, setYear] = useState('2025');
  const yearArray = ['2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025'];

  const isSelected = (yearValue: string): boolean => year === yearValue;
  const handleClick = (yearValue: string) => setYear(yearValue);

  useEffect(() => {
    setData(data[year as unknown as keyof typeof data]);
  }, [setData, year]);

  return (
    <SelectorContainer>
      <>
        {yearArray.map(yearValue => (
          <Year key={yearValue} isSelected={isSelected(yearValue)} onClick={() => handleClick(yearValue)}>
            {yearValue}
          </Year>
        ))}
      </>
    </SelectorContainer>
  );
};
